export default __webpack_public_path__ + "static/media/logo.7a5b1987.svg";